import React from "react";
import '../../styling/TicketStatus.css'; // Import the CSS file

export default function TicketStatusLog({ ticketstatuslog }) {

  const getSystemTimeZone = () => {
    const timeZone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString + 'Z');
    if (isNaN(date)) return '';

    const systemTimeZone = getSystemTimeZone();

    return date.toLocaleDateString('en-GB', {
      timeZone: systemTimeZone,
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }) + ' ' + date.toLocaleTimeString('en-GB', {
      timeZone: systemTimeZone,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };

  return (
    <div className='ticket-status-log'>
      <h2 className="boremark-title">Ticket Status Log</h2>
      <table>
        <thead>
          <tr>
            <th scope="col" style={{ width: '120px' }} className="normal-col">Stage</th>
            <th scope="col" style={{ width: '120px' }} className="normal-col">Status</th>
            <th scope="col" style={{ width: '120px' }} className="normal-col">Created On</th>
          </tr>
        </thead>
        <tbody>
          {ticketstatuslog && ticketstatuslog.length > 0 ? (
            ticketstatuslog.map((progress) => {
              return (
                <tr key={progress.id}>
                  <td>{progress.stage}</td>
                  <td>{progress.status ?? "-"}</td>
                  <td>{formatDate(progress.createdDate) ?? "-"}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="3" style={{ height: '500px' }} className="text-center">No status available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
